export default __webpack_public_path__ + "static/media/taxi.f969214a.jpg";